export const UPDATE_GESTIONE_SEPARATA 		        = 'UPDATE_GESTIONE_SEPARATA';
export const UPDATE_LINEA_LIBERA 	  		        = 'UPDATE_LINEA_LIBERA';
export const UPDATE_LINEA_GUIDATA 	  		        = 'UPDATE_LINEA_GUIDATA';
export const UPDATE_LINEE_GUIDATE_TUTTE 	  	    = 'UPDATE_LINEE_GUIDATE_TUTTE';
export const UPDATE_RIBILANCIAMENTO   		        = 'UPDATE_RIBILANCIAMENTO';
export const SALVA_DATI_RIPARTIZIONE_PREMIO         = 'SALVA_DATI_RIPARTIZIONE_PREMIO';
export const SALVA_ESITO_PERCENTUALE_ALLOCAZIONE    = 'SALVA_ESITO_PERCENTUALE_ALLOCAZIONE';
export const UPDATE_DATI_RIPARTIZIONE_PREMIO_VALIDA = 'UPDATE_DATI_RIPARTIZIONE_PREMIO_VALIDA';